import { render, staticRenderFns } from "./ProuniAcceptanceForm.vue?vue&type=template&id=191a6e4d&scoped=true&"
import script from "./ProuniAcceptanceForm.vue?vue&type=script&lang=ts&"
export * from "./ProuniAcceptanceForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniAcceptanceForm.vue?vue&type=style&index=0&id=191a6e4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a6e4d",
  null
  
)

export default component.exports